export var PeopleMenuOverrides = /*#__PURE__*/function (PeopleMenuOverrides) {
  PeopleMenuOverrides["createTeamsDisabled"] = "create-teams-disabled";
  PeopleMenuOverrides["viewTeamsDisabled"] = "view-teams-disabled";
  return PeopleMenuOverrides;
}({});